import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../helpers/fetch-wrapper";
import HttpStatus from "./../helpers/status.enum";

/* Create slice */
const name = "checkin";
const reducers = createReducers();
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

/* Exports */
export const checkInActions = { ...slice.actions, ...extraActions };
export const checkInReducer = slice.reducer;

/* Implementation */
function createInitialState() {
  return {
    bookingSlug: null,
    listingSlug: null,
    bookingData: null,
    checkinDate: null,
    checkoutDate: null,
  };
}


function createReducers() {
  return {
    setBookingSlugCode,
    setListingSlugCode,
    setBookingData,
    setCheckinDate,
    setCheckoutDate,
  };

  function setBookingSlugCode(state, action) {
    state.value = action.payload;
    state.bookingSlug = action.payload;
  }

  function setListingSlugCode(state, action) {
    state.listingSlug = action.payload;
  }

  function setCheckinDate(state, action) {
    state.checkinDate = action.payload || null;
  }

  function setCheckoutDate(state, action) {
    state.checkoutDate = action.payload || null;
  }
  function setBookingData(state, action) {
    state.bookingData = action.payload || null;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/checkin`;

  return {
    getBookingByCode: getBookingByCode(),
    getAgrrements: getAgrrements(),
    emailVerification: emailVerification(),
    verifyOtp: verifyOtp(),
    getBookingInfo: getBookingInfo(),
    markContinueAccepted: markContinueAccepted(),
    getHostDetails: getHostDetails(),
    verifyPostInfoOtp: verifyPostInfoOtp(),
    checkFormStatus: checkFormStatus(),
    createVeriffSeason: createVeriffSeason(),
  };

  /* To get booking detail by passing the request */
  function getBookingInfo() {
    return createAsyncThunk(
      `${name}/getBookingDetails`,
      async (request, { dispatch }) => {
        const result = await fetchWrapper.post(`${baseUrl}/booking-info`, request);
        if (result.status === HttpStatus.HTTP_OK) {
          const bookingSlug = result?.result?.booking_slug ?? null;
          const listingSlug = result?.result?.listing?.slug ?? null;
          const checkinDate = result?.result?.checkin_datetime  || null;
          const checkoutDate = result?.result?.checkout_datetime || null;
          dispatch(checkInActions.setBookingSlugCode(bookingSlug));
          dispatch(checkInActions.setListingSlugCode(listingSlug));
          dispatch(checkInActions.setBookingData(result.result));
          dispatch(checkInActions.setCheckinDate(checkinDate));
          dispatch(checkInActions.setCheckoutDate(checkoutDate));
        }
        return result;
      }
    );
  }

  /* Get booking by passing the confirmation code */
  function getBookingByCode() {
    return createAsyncThunk(
      `${name}/getBookingByCode`,
      async (request, { dispatch }) => {
        const { booking_slug = "", from_sms = false } = typeof request === "string" ? { booking_slug: request } : request;
        let bookingUrl = `${baseUrl}/${booking_slug}`;
        if(from_sms){
          bookingUrl += `?redirect_from_sms=${from_sms}`;
        }
        const result = await fetchWrapper.get(bookingUrl);
        /* Set confirmation code in redux */
        if (result.status === HttpStatus.HTTP_OK) {
          const bookingSlug = result.result && result.result.booking_slug ? result.result.booking_slug : null;
          // dispatch(checkInActions.setBookingSlugCode(bookingSlug));
          const checkinDate  = result?.result?.checkin_date ||result?.result?.checkin_datetime  || null;
          const checkoutDate = result?.result?.checkout_date || result?.result?.checkout_datetime || null;
          dispatch(checkInActions.setCheckinDate(checkinDate));
          dispatch(checkInActions.setCheckoutDate(checkoutDate));
        }
        return result;
      }
    );
  }

  /* To send the verification to user's registered email id */
  function emailVerification() {
    return createAsyncThunk(
      `${name}/emailVerification`,
      async (request) => await fetchWrapper.post(`${baseUrl}/email-verification`, request)
    );
  }

  /* To verify the user OTP */
  function verifyOtp() {
    return createAsyncThunk(
      `${name}/verifyOtp`,
      async (request) => await fetchWrapper.post(`${baseUrl}/verify-otp`, request)
    );
  }

  /* Get booking by passing the confirmation code */
  function getAgrrements() {
    return createAsyncThunk(
      `${name}/getAgrrements`,
      async (id, { dispatch }) => {
        const result = await fetchWrapper.get(`${baseUrl}/agreement-list/${id}`);
        return result;
      }
    );
  }

  /* Get booking by passing the confirmation code */
  function markContinueAccepted() {
    return createAsyncThunk(
      `${name}/markContinueAccepted`,
      async (id, { dispatch }) => {
        const result = await fetchWrapper.get(`${baseUrl}/accept-continue/${id}`);
        return result;
      }
    );
  }

  /* To send the verification to user's registered email id */
  function getHostDetails() {
    return createAsyncThunk(
      `${name}/getHostDetails`,
      async (request, { dispatch }) => {
        const result = await fetchWrapper.post(`${baseUrl}/get-host-detail`, request);
        if (result.status === HttpStatus.HTTP_OK) {
          const listingSlug = result?.result?.listing_slug ?? null;
          dispatch(checkInActions.setListingSlugCode(listingSlug));
        }
        return result;
      }
    );
  }

  /* To verify post info the user OTP */
  function verifyPostInfoOtp() {
    return createAsyncThunk(
      `${name}/verifyPostInfoOtp`,
      async (request) => await fetchWrapper.post(`${baseUrl}/verify-post-info-otp`, request)
    );
  }

  /* To send form deletion email */
  function checkFormStatus() {
    return createAsyncThunk(
      `${name}/checkFormStatus`,
      async (request) => await fetchWrapper.post(`${baseUrl}/check-form-status`, request)
    );
  }

  /* To create session for veriff verification */
  function createVeriffSeason() {
    return createAsyncThunk(
      `${name}/createVeriffSeason`,
      async (request) => await fetchWrapper.post(`${baseUrl}/veriff-sessions`, request)
    );
  }
}
